import { Editor } from 'slate'
import { oneOf, string } from 'prop-types'
import { useContext } from 'react'
import { useSlateStatic } from 'slate-react'
import cc from 'classcat'

import { ToolbarContext } from '../RichTextEditor'
import { isAnyLinkSelected, isLinkFocused, unlink } from '../links'
import { isButtonFocused } from '../buttons'

export default function LinkButton({ title, format }) {
  const editor = useSlateStatic()
  const [{ isLinkTooltipOpen: isOpen, isColorPickerOpen, isButtonLinkTooltipOpen }, toolbarDispatch] =
    useContext(ToolbarContext)

  const isButtonActive = isButtonFocused(editor) || isButtonLinkTooltipOpen
  const isActive = isLinkFocused(editor) || isOpen
  const hasAnyLinks = isAnyLinkSelected(editor)
  const multipleParagraphsSelected =
    Array.from(Editor.nodes(editor, { match: (n) => n.type === 'paragraph' })).length > 1
  const multipleListsSelected =
    Array.from(Editor.nodes(editor, { match: (n) => n.type === 'list-item-child' })).length > 1

  function handleMouseDown(event) {
    event.preventDefault()

    if (format === 'link') toolbarDispatch({ type: 'open_link_tooltip' })
    else if (format === 'unlink') unlink(editor)
  }

  return (
    <button
      className={cc([
        'dali-plugin-text-toolbar-button',
        `dali-plugin-text-toolbar-button-${format}`,
        { active: isActive && format === 'link' },
      ])}
      data-command-name={format}
      type="button"
      title={title}
      onMouseDown={handleMouseDown}
      disabled={
        (!editor.selection && !isOpen && !isColorPickerOpen) ||
        isButtonActive ||
        (format === 'unlink' && !hasAnyLinks) ||
        (format === 'link' && !isActive && (hasAnyLinks || multipleParagraphsSelected || multipleListsSelected))
      }
    />
  )
}

LinkButton.propTypes = { title: string.isRequired, format: oneOf(['link', 'unlink']) }
